import { LabOrder } from '../shared/data/lab-order';
import { LabOrderBusinessService } from '../shared/lab-order-business.service';
import {Component, OnDestroy, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { LabCodeMapperService } from '../lab-code-mapper/lab-code-mapper.service';
import { CoatingTypes } from '../shared/data/coatingTypes';
import {UtilsService} from '../shared/utils.service';
import {SubscriptionsContainer} from '../shared/subscriptions-container';
import {DataConstants} from '../shared/data/data-constants';
import { Messages } from '../shared/messages';
import { ClearMessagesService } from '../shared/clear-messages.service';

@Component({
  selector: 'app-vieworder',
  templateUrl: './vieworder.component.html',
  styleUrls: ['./vieworder.component.css']
})
export class VieworderComponent implements OnInit, OnDestroy {
  data: LabOrder;
  labOrderNumber: string;
  message: any;
  queryReturned: boolean;
  supplierName: string;
  materialType: string;
  pdMeasurementType: string;
  setDisable: boolean;
  modifyTooltipText = 'Modify Order';
  subs = new SubscriptionsContainer();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private labCodeMapperService: LabCodeMapperService,
    private labOrderBusinessService: LabOrderBusinessService,
    private clearMessagesService: ClearMessagesService,
    private coatingTypes: CoatingTypes
  ) { }

  ngOnInit() {
    console.log('init()');
    this.subs.add = this.route.params.subscribe(params => {
      this.labOrderNumber = params['labOrderNumber'];
    });

    console.log('retrieved parameter: ' + this.labOrderNumber);
    this.queryReturned = false;
    this.subs.add = this.labOrderBusinessService.viewLabOrder(this.labOrderNumber)
      .subscribe(
        (labOrder) => {
          labOrder = this.labCodeMapperService.initializeLabOrderMapping(labOrder);
          console.log('Successfully viewed order: ' + this.labOrderNumber, labOrder);
          this.data = labOrder;
          this.queryReturned = true;
          this.formatTextToMixCases();
          // Do not allow the user to modify legacy VSP orders
          if (!UtilsService.isPrivateOrder(this.data) && !UtilsService.isAPIOrder(this.data)) {
            this.modifyTooltipText = 'Unable to Modify this Order';
            this.setDisable = true;
          }
        },
        (error) => {
          this.data = null;
          console.error('Unable to view order \'' + this.labOrderNumber + '\'. ' + error.message);
          alert('Unable to lookup order \'' + this.labOrderNumber + '\'.');
        }
      );
  }

  // Convert Enum names into Mix cases text
  formatTextToMixCases() {
    this.supplierName = UtilsService.lowerCaseAllWordsExceptFirstLetters(this.data.frame.supplier);
    this.materialType = UtilsService.lowerCaseAllWordsExceptFirstLetters(this.data.frame.materialType);
    this.pdMeasurementType = UtilsService.lowerCaseAllWordsExceptFirstLetters(this.data.prescription.pdMeasurementType);
  }
  ngOnDestroy(): void {
    console.log(' View Order Component - ngOnDestroy ' );
    this.subs.dispose();
  }

  public submit(action) {

    switch (action) {
      case 'ACCEPT' :
        this.acceptOrder(this.data.labOrderNumber, this.data.labInvoiceNumber);
        break;
      // case 'VIEW' : this.viewOrder(); break;
      // case 'ASSIGN' : this.assignInvoiceNumber(); break;
      case 'COMPLETE' :
        this.completeOrder(this.data.labOrderNumber, this.data.labInvoiceNumber);
        break;
      case 'MODIFY' :
        this.modifyOrder(this.data.labOrderNumber, this.data.labInvoiceNumber);
        break;
      case 'VOID' :
        this.voidOrder(this.data.labOrderNumber, this.data.labInvoiceNumber);
        break;
      default :
        console.log('Unknown submission.');
    }
  }

  public submitModal(input) {
    console.log('submitModal: ', input);

    const action = input.action;

    switch (action) {
      case 'ACCEPT':
        this.acceptOrder(this.data.labOrderNumber, input.invoiceNumber);
        break;
      case 'COMPLETE':
        this.completeOrder(this.data.labOrderNumber, input.invoiceNumber);
        break;
      case 'MODIFY':
        this.modifyOrder(this.data.labOrderNumber, input.invoiceNumber);
        break;
      case 'ASSIGN':
        this.assignInvoiceNumber(this.data.labOrderNumber, input.invoiceNumber);
        break;
      case 'VOID':
        this.voidOrder(this.data.labOrderNumber, input.invoiceNumber);
        break;

      default : console.log('Unknown submission.');
      break;
    }
  }

  // This method will first check if there is an order to view.
  private modifyOrder(labOrderNumber: string, labInvoiceNumber: string) {
    console.log('labOrderNumber: ' + labOrderNumber);
    console.log('Assign Invoice Number: ' + labInvoiceNumber);

    this.subs.add = this.labOrderBusinessService.viewLabOrder(labOrderNumber)
      .subscribe(
        (labOrder) => {
          if (UtilsService.isPrivateOrder(labOrder) || UtilsService.isAPIOrder(labOrder)) {
            console.log('Redirecting to labOrderNumber ' + labOrderNumber);
            this.router.navigate(['modifyOrder/', labOrderNumber], {queryParams: {'labInvoiceNumber': labInvoiceNumber}});
          } else {
            // inform user that order is not available for update
            this.message = Messages.LEGACY_VSP_ORDER_NOT_UPDATABLE_MESSAGE;
            console.error('Error modifying order: ' + this.message);
            alert(this.message);
          }
        },
        (error) => {
          console.error('Unable to verify order \'' + labOrderNumber + '\' exists: ' + error.message);
          alert('Unable to find order \'' + labOrderNumber + '\'.');
        }
      );
  }

  public acceptOrder(labOrderNumber: string, labInvoiceNumber: string) {
    console.log('Accept request received for: ' + labOrderNumber);
    console.log('Assign Invoice Number: ' + labInvoiceNumber);

    this.subs.add = this.labOrderBusinessService.acceptLabOrder(labOrderNumber, labInvoiceNumber)
      .subscribe(
        (labOrder) => {
          const message = 'Successfully accepted order: ' + labOrder.labOrderNumber;
          console.log(message);
          labOrder = this.labCodeMapperService.initializeLabOrderMapping(labOrder);
          this.data = labOrder;
          this.message = message;
          alert('Successfully accepted Lab Order ' + labOrder.labOrderNumber);
        },
        (error) => {
          this.message = error.message;
          console.error('Error accepting order: ' + error.message);
          alert('Error accepting Lab Order ' + labOrderNumber + ': ' + error.message);
        }
      );
  }

  private voidOrder(labOrderNumber: string, labInvoiceNumber) {
    console.log('Void order: ' + labOrderNumber);

    // Don't clear old message for void
    this.clearMessagesService.setClearMessages(false);
    this.subs.add = this.labOrderBusinessService.voidLabOrder(labOrderNumber, labInvoiceNumber)
      .subscribe(
        (labOrder) => {
          const message = 'Successfully voided order: ' + labOrder.labOrderNumber;
          console.log(message);
          this.data = labOrder;
          this.router.navigate(['/orders', {message: message}]);
        },
        (error) => {
          this.message = error.message;
          console.error('Error voiding order: ' + error.message);
          alert('Error voiding labOrder. ' + error.message);
        }
      );
  }

  public completeOrder(labOrderNumber, labInvoiceNumber): string {
    console.log('Complete order request received for: ' + labOrderNumber);
    console.log('Assign Invoice Number: ' + labInvoiceNumber);

    this.subs.add = this.labOrderBusinessService.completeLabOrder(labOrderNumber, labInvoiceNumber)
      .subscribe(
        (labOrder) => {
          const message = 'Successfully completed laborder: ' + labOrder.labOrderNumber;
          console.log(message);
          labOrder = this.labCodeMapperService.initializeLabOrderMapping(labOrder);
          this.data = labOrder;
          this.message = message;
        },
        (error) => {
          this.message = error.message;
          console.error('Error completing order: ' + error.message);
          alert('Error completing labOrder. ' + error.message);
        }
      );
    return;
  }

  // This method will assign invoice number to the lab order.
  public assignInvoiceNumber(labOrderNumber: string, labInvoiceNumber: string) {
    console.log('Assign Invoice Number ' + labInvoiceNumber + ' for: ' + labOrderNumber);
    // if invoice number is specified, let's make sure it's not more than 11 chars.
    if (labInvoiceNumber && labInvoiceNumber.length > DataConstants.INVOICE_NUMBER_LENGHT) {
      alert('Invoice number should be ' + DataConstants.INVOICE_NUMBER_LENGHT + ' characters or less.');
      return;
    }

    this.subs.add = this.labOrderBusinessService.assignInvoiceNumber(labOrderNumber, labInvoiceNumber)
      .subscribe(
        (labOrder) => {
          this.data = labOrder;
          // show a different prompt for setting a invoice number with a value.
          if (labInvoiceNumber && labInvoiceNumber.trim() !== '') {
            console.log('Successfully assigned invoice number: ' + labInvoiceNumber + ' to order number ' + labOrderNumber);
            alert('Successfully assigned invoice number \''+ labInvoiceNumber + '\'');
          }
          // assume any blank value is clearing the invoice number.
          else {
            console.log('Successfully cleared invoice number from order number ' + labOrderNumber);
            alert('Successfully cleared invoice number');
          }
        },
        (error) => {
          console.error('Unable to assign invoice number: ' + labInvoiceNumber + ' to order number '
            + labOrderNumber + ': ' + error.message);
          alert('Unable to assign invoice number to order \'' + labOrderNumber + '\'.');
        }
      );
  }

}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/vieworder/vieworder.component.ts